import RecommendPolicy from "./RecommendPolicy";
export default RecommendPolicy;
